import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { getFirestore, doc, updateDoc, onSnapshot } from 'firebase/firestore';
import appFirebase from '../../Firebase/Firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser, faMoneyBill, faWallet, faCalendarAlt, faComments, faSignOutAlt,
    faSitemap, faUserGroup
} from '@fortawesome/free-solid-svg-icons';
import { Menu, X } from 'lucide-react';
import logoClaro from '../../img/logoDark.png';
import logo from '../../images/Logo.png';
import coworkingB from '../../img/coworkingB.png';
import serviciosB from '../../img/servicioB.png';
import academiaB from '../../img/academiaB.png';
import coworkingN from '../../img/coworkingN.png';
import serviciosN from '../../img/servicioN.png';
import academiaN from '../../img/academiaN.png';
import { onAuthStateChanged } from 'firebase/auth';
import './NavBarMobile.css';
function NavbarMobileVersion({ isDarkMode, toggleDarkMode }) {
    const handleMenuLinkClick = () => {
        setMenuOpen(false);
    };
    const [avatarName, setAvatarName] = useState('userAvatar1');
    const [role, setRole] = useState('');
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [usuario, setUsuario] = useState(null);
    const [userName, setUserName] = useState('');
    const [scrollDirection, setScrollDirection] = useState(null);
    const toggleUserMenu = () => setUserMenuOpen(!userMenuOpen);
    const userMenuRef = useRef(null);

    const getAvatarSrc = (avatarName) => avatarsMap[avatarName] || avatarsMap.userAvatar1;
    const avatarsMap = {
        userAvatar1: require('../../images/1.png'),
        userAvatar2: require('../../images/2.png'),
        userAvatar3: require('../../images/3.png'),
        userAvatar4: require('../../images/4.png'),
        userAvatar5: require('../../images/5.png'),
        userAvatar6: require('../../images/6.png'),
        userAvatar7: require('../../images/7.png'),
        userAvatar8: require('../../images/8.png'),
    };
    const handleProfileClick = () => { setUserMenuOpen(false); navigate('/myprofile'); };
    const handleSignOut = () => { signOut(auth); setUserMenuOpen(false); };
    const navigate = useNavigate();
    const auth = getAuth();
    const db = getFirestore(appFirebase);
    const [uid, setUid] = useState(null);
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setUsuario(user);
                const userDocRef = doc(db, 'usuarios', user.uid);
                return onSnapshot(userDocRef, (doc) => {
                    if (doc.exists()) {
                        const data = doc.data();
                        setRole(data.role);
                        setUserName(data.name || '');
                        setAvatarName(data.avatar || 'userAvatar1');
                    }
                });
            } else {
                setUsuario(null);
                setRole('');
                setUserName('');
                setAvatarName('userAvatar1');
            }
        });
        return () => unsubscribe();
    }, []);
    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const unsub = onAuthStateChanged(auth, user => {
            if (user) setUid(user.uid);
        });
        return unsub;
    }, []);

    useEffect(() => {
        function handleClickOutside(event) {
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setUserMenuOpen(false);
            }
        }
        if (userMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [userMenuOpen]);
    useEffect(() => {
        const handleScrollDirection = () => {
            if (window.scrollY) {
                setUserMenuOpen(false);
            }
            if (window.scrollY > lastScrollY) {
                setScrollDirection('down');
            } else {
                setScrollDirection('up');
            }
            lastScrollY = window.scrollY;
        };
        window.addEventListener('scroll', handleScrollDirection);
        return () => window.removeEventListener('scroll', handleScrollDirection);
    }, []);

    return (
        <nav className={`navbar_m ${scrolled ? 'scrolled' : ''}`}>
            <div className="navbar__mobile">
                <ul className="navbar__bottom-menu">
                    <li>
                        <Link to="/coworking">
                            <img
                                src={isDarkMode ? coworkingN : coworkingB}
                                className={`iconos-navbar4 ${scrolled ? 'hide-on-scroll' : ''}`}
                            />
                            <span>Coworking</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/servicios">
                            <img
                                src={isDarkMode ? serviciosN : serviciosB}
                                className={`iconos-navbar4 ${scrolled ? 'hide-on-scroll' : ''}`}
                            />
                            <span>Servicios</span>
                            <span className={`new-badge ${scrolled ? 'hide-on-scroll' : ''}`}>NOVEDAD</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="https://edu-laofi-academy.odoo.com/home-academy" target="_blank">
                            <img
                                src={isDarkMode ? academiaN : academiaB}
                                className={`iconos-navbar4 ${scrolled ? 'hide-on-scroll' : ''}`}
                            />
                            <span>Academia</span>
                            <span className={`new-badge ${scrolled ? 'hide-on-scroll' : ''}`}>NOVEDAD</span>
                        </Link>
                    </li>

                </ul>
                <div className={`navbar__bottom-fixed ${scrollDirection === 'down' ? 'hide' : 'show'}`}>
                    <div className="bottom-fixed-content">
                        <Link to="/">
                            <img src={isDarkMode ? logoClaro : logo} alt="logo" className="logo-img" />
                        </Link>

                        <label className="switch">
                            <input type="checkbox" onChange={toggleDarkMode} checked={isDarkMode} />
                            <span className="slider"><span className="thumb-icon">{isDarkMode ? '🌙' : '🌞'}</span></span>
                        </label>

                        {/*!usuario ? <Link to="/login" className='modo-anfitrion'>Conviértete en Anfitrión</Link> : <Link to="/#" className='modo-anfitrion'>Modo Anfitrión</Link>*/}
                        <div className="cuenta-icon">

                            {!usuario ? (
                                <Link to="/login" className="modo-anfitrion">
                                    <FontAwesomeIcon icon={faUser} style={{ marginRight: '6px' }} />
                                    Iniciar sesión
                                </Link>
                            ) : (
                                <div className="navbar__account-button" onClick={toggleUserMenu} ref={userMenuRef}>
                                    <img src={getAvatarSrc(avatarName)} alt="Avatar" className="navbar__avatar" />Mi Cuenta
                                    {userMenuOpen && (
                                        <ul className="navbar__submenu">
                                            <span className="navbar__username">{userName}</span><br />
                                            <small className="user-email">{usuario.email}</small>
                                            <li onClick={handleProfileClick}><FontAwesomeIcon icon={faUser} /> Perfil</li>
                                            {role === 'admin' && (
                                                <ul>
                                                    <li>
                                                        <Link to="/create-coin-package" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faMoneyBill} /> Crear Paquete de Monedas</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/verficarCoinsComprados" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faSitemap} /> Verificar Compras</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Reservas_Admin" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faCalendarAlt} /> Reservas</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/space" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faSitemap} /> Pon tu espacio</p>
                                                        </Link>
                                                    </li>

                                                    <li>
                                                        <Link to="/users" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faUserGroup} /> Usuarios</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Busquedas" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faCalendarAlt} />Busquedas</p>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            )}
                                            {role === 'user' && (
                                                <>
                                                    <li>
                                                        <Link to="/wallet" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faWallet} /> Wallet</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/reservasRealizadas" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faCalendarAlt} /> Mis Reservas</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/coin-purchase" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faComments} /> Comentarios</p>
                                                        </Link>
                                                    </li>
                                                </>
                                            )}
                                            {
                                                role === 'prov' && (
                                                    <>
                                                        <li>
                                                            <Link to="/wallet" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faWallet} /> Wallet</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/Reservas_Admin" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faCalendarAlt} /> Reservas</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/space" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faSitemap} />Pon tu espacio</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/proveedor/misMarcas" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faSitemap} /> Administra tu marca</p>
                                                            </Link>
                                                        </li>
                                                        <Link to="/coin-purchase" onClick={handleMenuLinkClick}>
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faComments} /> Comentarios</p>
                                                        </Link>

                                                        <li>
                                                            <Link to="/users" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"> <FontAwesomeIcon icon={faUserGroup} /> Clientes</p>
                                                            </Link>
                                                        </li>
                                                    </>
                                                )
                                            }                                            <li onClick={handleSignOut}><FontAwesomeIcon icon={faSignOutAlt} /> Cerrar sesión</li>
                                        </ul>
                                    )}
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div></nav>
    )
}
export default NavbarMobileVersion;